import { allocateStat } from '../../domain/progress/progression';
import { clearSaveFromStorage, readSaveFromStorage } from '../../domain/save/saveGame';
import { createInitialData } from '../helpers';
import type { GameActions, GameStoreGet, GameStoreSet } from '../types';

export function createMetaActions(
  set: GameStoreSet,
  get: GameStoreGet,
): Pick<GameActions, 'allocateStatPoint' | 'saveGame' | 'loadGame' | 'deleteSave' | 'reset'> {
  return {
    allocateStatPoint: (stat) => {
      const { player, mode } = get();
      if (!player.alive || mode.type === 'combat') {
        return;
      }
      const next = allocateStat(player, stat);
      set(
        next
          ? { player: next, lastMessage: `+1 ${stat}. Còn ${next.statPoints} điểm.` }
          : { lastMessage: 'Không còn điểm chỉ số.' },
      );
    },

    saveGame: () => {
      if (!get().player.alive) {
        set({ lastMessage: 'Không thể lưu sau khi đã chết.' });
        return;
      }
      // Pha Lê là bắt buộc; useItem xử lý cả ngoài/trong combat.
      get().useItem('memory_crystal');
    },

    loadGame: () => {
      const snapshot = readSaveFromStorage();
      if (!snapshot) {
        set({ lastMessage: 'Không có bản lưu hợp lệ.' });
        return;
      }
      set({
        player: snapshot.player,
        dungeon: snapshot.dungeon,
        mode: snapshot.mode,
        combat: snapshot.combat,
        previousRoomId: snapshot.previousRoomId,
        lastMessage: snapshot.lastMessage ?? 'Đã nạp bản lưu.',
        hasSave: true,
      });
    },

    deleteSave: () => {
      clearSaveFromStorage();
      set({ hasSave: false, lastMessage: 'Đã xóa bản lưu.' });
    },

    reset: () => set(createInitialData()),
  };
}
